import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private jwtHelper: JwtHelperService
  ) { }

  login({ email, password }: any): any {
    return this.http.post(`${environment.apiUrl}/login`, { email, password });
  }

  isAuthenticated() {
    const userData: any = localStorage.getItem('user');
    const user = JSON.parse(userData);
    if (user) {
      return !this.jwtHelper.isTokenExpired(user.accessToken);
    }
    return false;
  }

  hasRole(roles: string[]) {
    const userData: any = localStorage.getItem('user');
    const user = JSON.parse(userData);
    if (user) {
      const jwtPayload = this.jwtHelper.decodeToken(user.accessToken)
      return jwtPayload.roles.some((role: any) => roles.includes(role));
    }
    return false;
  }


  getUser() {
    const userData: any = localStorage.getItem('user');
    const user = JSON.parse(userData);
    return user;
  }

  logout() {
    localStorage.removeItem('user');
  }

}
